declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_structural_complex_key_foo extends $mol_object {
		dictionary( ): ({ 
			'raw data key': string,
			'key2': string,
			'key3': string,
		}) 
	}
	
}

//# sourceMappingURL=structural_complex_key.view.tree.d.ts.map